/**
 * adyen支付方式类型
 */
export enum AdyenPaymentMethodType {
  SCHEME = 'scheme',
  GOOGLE_PAY = 'googlepay',
  PAY_WITH_GOOGLE = 'paywithgoogle',
  APPLE_PAY = 'applepay',
  PAYPAL = 'paypal',
  WECHATPAY_WEB = 'wechatpayWeb',
  WECHATPAY_QR = 'wechatpayQR',
}
